<template>
  <!-- badge: resumen para tablas (color del nivel más alto) -->
  <span v-if="mode == 'badge'">
    <b-badge v-if="avisos.length" :variant="levelVariant(maxLevel)" v-b-tooltip.hover.html :title="tooltip">
      {{avisos.length}} aviso(s)
    </b-badge>
    <span v-else class="text-muted">—</span>
  </span>

  <!-- list: detalle de cada aviso -->
  <div v-else>
    <div v-if="!reported" class="text-muted">Sin datos reportados</div>
    <div v-else-if="!avisos.length" class="text-success"><AppIcon name="check_circle" /> Sin avisos</div>
    <div v-else>
      <div v-for="(aviso, index) in sorted" :key="index" class="monitor-avisos__item" :class="'monitor-avisos__item--' + levelVariant(aviso.level)">
        <div class="d-flex justify-content-between align-items-start">
          <div>
            <b-badge :variant="levelVariant(aviso.level)" class="mr-1">{{levelLabel(aviso.level)}}</b-badge>
            <b>{{aviso.titulo}}</b>
          </div>
          <small class="text-muted text-nowrap ml-2" v-b-tooltip.hover :title="formatDate(aviso.fecha_hora)">{{timeAgo(aviso.fecha_hora)}}</small>
        </div>
        <div class="monitor-avisos__message">{{aviso.mensaje}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  // formato de monitor_avisos (definido con Monitor):
  // [{titulo, mensaje, level: info|warning|critical, fecha_hora: Y-m-d H:i:s}]
  const LEVELS = {
    critical: { order: 3, variant: 'danger', label: 'Crítico' },
    warning: { order: 2, variant: 'warning', label: 'Advertencia' },
    info: { order: 1, variant: 'info', label: 'Info' },
  }

  import { timeAgo, formatDate } from './monitorConfig'

  export default {
    props: {
      value: { default: null },
      mode: { type: String, default: 'badge' },
    },
    computed: {
      reported() {
        return this.value !== null && this.value !== undefined && this.value !== ''
      },
      avisos() {
        if(!this.reported) return []
        var data = this.value
        if(typeof data == 'string') {
          try {
            data = JSON.parse(data)
          } catch (error) {
            return []
          }
        }
        return Array.isArray(data) ? data : []
      },
      sorted() {
        return this.avisos.slice().sort((a, b) => this.levelOrder(b.level) - this.levelOrder(a.level))
      },
      maxLevel() {
        return this.sorted.length ? this.sorted[0].level : null
      },
      tooltip() {
        return this.sorted.map(aviso => '<b>' + this.levelLabel(aviso.level) + ':</b> ' + this.escape(aviso.titulo)).join('<br>')
      },
    },
    methods: {
      timeAgo,
      formatDate,
      levelOrder(level) {
        return LEVELS[level] ? LEVELS[level].order : 0
      },
      levelVariant(level) {
        return LEVELS[level] ? LEVELS[level].variant : 'secondary'
      },
      levelLabel(level) {
        return LEVELS[level] ? LEVELS[level].label : level
      },
      escape(text) {
        return String(text || '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c])
      },
    }
  }
</script>

<style scoped>
  .monitor-avisos__item {
    border-left: 3px solid #adb5bd;
    padding: 6px 10px;
    margin-bottom: 6px;
    background: rgba(0, 0, 0, 0.02);
  }

  .monitor-avisos__item--danger { border-left-color: #dc3545; }
  .monitor-avisos__item--warning { border-left-color: #ffc107; }
  .monitor-avisos__item--info { border-left-color: #17a2b8; }

  .monitor-avisos__message {
    white-space: pre-wrap;
    margin-top: 2px;
  }
</style>
